import { FinanceTypeenum } from "@gtpl/shared-models/common-models"

export class ExpensesModelDto{
    id:number
    head: string
    category: string
    month: number
    amount: number
    year: number
    type: FinanceTypeenum

    // createdUser: string | null
    // createdAt: Date
    // updatedAt: Date
    // updatedUser: string | null

    constructor(

        id:number,
        head: string,
        category: string,
        month: number,
        amount: number,
        year: number,
        type: FinanceTypeenum

    ){
this.id=id
this.head = head
this.category = category
this.month = month
this.amount = amount
this.year = year
this.type = type

    }
      
    }

    export class ExpensesModelDtoReq{
        formData :ExpensesModelDto[]
        user:string
        constructor(
            formData :ExpensesModelDto[],
        user:string
        ) {
            this.formData = formData
            this.user = user
        } }
